





































































import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * Utils
 */
import { getElegantDateString, getTimeSince } from "@/utils/date-helpers";

/**
 * Components
 */

/**
 * API
 */

/**
 * Types
 */

export interface TeamContributions {
	id: number;
	name: string;
	teamPremiumLevel: string;
	myContribution: number;
	totalActiveContributions: number;
	isMyContributionActive: boolean;
}

export interface UserDetails {
	premium: {
		bonuses: {
			availableBoostCredits: number;
			maxBoostCredits: number;
		} | null;
	};
}


@Component
export default class TeamContributionCard extends Vue {
	/// Injections
	getTimeSince = getTimeSince;
	getElegantDateString = getElegantDateString;

	/// Properties
	@Prop({required: true}) teamContributions!: TeamContributions;
	@Prop({default: false}) isLoading!: boolean;
	@Prop({required: true}) userDetails!: UserDetails;

	get max() {
		return this.userDetails.premium.bonuses?.maxBoostCredits ?? 0;
	}

	get current() {
		return this.teamContributions.myContribution;
	}
}
